export default __webpack_public_path__ + "static/media/renew-icon.39b2cfe3.svg";